import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { LoadingContent } from '../../common/ui/loading-content';
import { goalPickerPopoverEntryPoint } from './entrypoint';
import type { GoalsPopupProps } from './types';

export const GoalsPopup = (props: GoalsPopupProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		goalPickerPopoverEntryPoint,
		{},
	);

	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="jwm.goals.picker.edit.popup"
			packageName="jiraBusinessGoalPicker"
			runtimeProps={props}
			fallback={<LoadingContent />}
			errorFallback="flag"
		/>
	);
};
